import PropTypes from 'prop-types';
import { Item } from '../Item/Item';
import { style as styles } from './List.style';

const List = ({ items, onListChange, title, deviceType }) => {
  return (
    <div className="list-container">
      {deviceType === 'desktop' && <div className="lists-title">{title}</div>}
      <div className="items-container">
        {items.map((item) => (
          <Item onItemChange={onListChange} key={item.tagName} item={item} />
        ))}
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

List.propTypes = {
  items: PropTypes.array.isRequired,
  onListChange: PropTypes.func.isRequired,
  title: PropTypes.string,
  deviceType: PropTypes.array.isRequired,
};

List.defaultProps = {
  title: 'Mis listas',
};

export { List };
